module.exports = __webpack_public_path__ + "static/media/Primex.89dacb7c.jpeg";